import React from "react";
import { Navigate } from "react-router-dom";
import { authService } from "../services";

interface PublicRouteProps {
  children: React.ReactNode;
}

/**
 * PublicRoute component that redirects authenticated users to the dashboard.
 * Only shows the children (e.g., login page) if the user is NOT authenticated.
 */
export const PublicRoute: React.FC<PublicRouteProps> = ({ children }) => {
  const isAuthenticated = authService.isAuthenticated();

  if (isAuthenticated) {
    // Redirect to dashboard if already authenticated
    return <Navigate to="/admin/daily-cash" replace />;
  }

  return <>{children}</>;
};
